import { Command } from 'commands/Commands';

export class ChangeAddressLine extends Command {
	type: string = 'ChangeAddressLine';
	priority: number = 100;
}

export class ChangeAddressLine2 extends Command {
	type: string = 'ChangeAddressLine2';
	priority: number = 100;
}
